module.exports = __webpack_public_path__ + "img/plexus-1.d4bfb37b.png";